module.exports = __webpack_public_path__ + "img/phone.3b5ba212.svg";